<mm-spinner [loading]="tableState$"></mm-spinner>
<div class='errorMsgContainer' *ngIf="(tableState$ | async)?.hasError">
  <div class='documentWarning-icon'></div>
  <div class='main-msg'>Can't load standing authorizations</div>
  <div class='secondary-msg'>Sorry for the inconvenience.<br>Please try again.</div>
  <a (click)="refreshAccount(accountId)" class='refresh-msg'>Refresh page</a>
</div>
<ng-template [ngIf]="!(tableState$ | async)?.hasError && (tableState$ | async)?.hasEmptyResponse && !(tableState$ | async)?.loading">
    <div class='errorMsgContainer'>
      <div class='main-msg' *ngIf="!params.noRowsMessageFn().isBookmarkFilterApplied">{{noRowsMessageTemplates.standingAuthHeader}}</div>
      <div class='main-msg' *ngIf="params.noRowsMessageFn().isBookmarkFilterApplied">{{noRowsMessageTemplates.bookmarks}}</div>
    </div>
</ng-template>
